import React, { FC } from 'react'

import { IconOneNumberProps } from './IconOneNumber.types'
import * as Styled from './styles/IconOneNumber.style'

import { nonThemeableRules } from '../../ruleSet'

const IconOneNumber: FC<IconOneNumberProps> = ({
  size = nonThemeableRules.defaultSize as number as IconOneNumberProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconOneNumberProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 20 24' xmlns='http://www.w3.org/2000/svg'>
        <path d='M10.002 24V7.205H7.65l-4.508 2.87 1.4 2.318 2.372-1.507v8.238C2.944 17.791.262 14.056.25 9.844.238 5.63 2.898 1.88 6.86.523a9.71 9.71 0 0 1 10.885 3.33 9.863 9.863 0 0 1 .34 11.446c-1.695 2.544-8.083 8.7-8.083 8.7z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconOneNumber
